export default __webpack_public_path__ + "audio/e07af0e57ad7570d2512157553d1fe7c-NoFuel.wav";